import React from 'react';

import styles from '../css/CoveragePPUInfoFee.module.css';

export const CellWithTitle = ({
  title = '',
  description = '',
}) => (
  <div className={styles.cell}>
    <span className={styles.cellTitle}>
      {title}
    </span>

    <span className={styles.cellDescription}>
      {description}
    </span>
  </div>
);
